import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import config from 'constants/config'

const StepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(20)};
  height: ${rem(20)};
  border-radius: ${(props) => props.theme.borderRadius.round};
  background-color: ${({ theme }) => theme.palette.brand.primary.normal};
  color: ${({ theme }) => theme.palette.neutral.default.eight};
  flex-shrink: 0;

  @media (max-width: ${config.bp.mobile - 1}px) {
    margin-top: 1px;
  }
`

interface Props {
  stepNumber: number
  heading: string
  body: string
}

function CuratedTripsIntroStep({ stepNumber, heading, body }: Props) {
  return (
    <Group direction="horizontal" horizontalAlign="start" gap={12}>
      <StepNumber>
        <Caption variant="medium">{stepNumber}</Caption>
      </StepNumber>
      <div>
        <BodyText variant="medium" weight="bold">
          {heading}
        </BodyText>
        <BodyText variant="medium">{body}</BodyText>
      </div>
    </Group>
  )
}

export default CuratedTripsIntroStep
